import Header from '@/components/Header';
import SEO from '@/components/SEO';
import HeroSection from '@/components/HeroSection';
import ServicesSection from '@/components/ServicesSection';
import TestimonialsSection from '@/components/TestimonialsSection';
import TopicsSection from '@/components/TopicsSection';
import ProcessTimelineSection from '@/components/ProcessTimelineSection';
import CTASection from '@/components/CTASection';
import Footer from '@/components/Footer';
import badgeProvenExpert from '@/assets/badge-proven-expert.png';
import badgeFocusMoney from '@/assets/badge-focus-money.png';
import badgeCapital from '@/assets/badge-capital.jpg';
import partnerIhk from '@/assets/partner-ihk.png';
import partnerMorgenMorgen from '@/assets/partner-morgen-morgen.png';
import partnerFbXpert from '@/assets/partner-fb-xpert.png';

const TRUST_ITEMS = [
  { src: badgeProvenExpert, alt: 'ProvenExpert: 100 % Empfehlungen', h: 'h-14' },
  { src: badgeFocusMoney, alt: 'Focus Money: Hervorragende Finanzanalyse', h: 'h-16' },
  { src: badgeCapital, alt: 'Capital: Beste Finanzberater', h: 'h-14' },
  { src: partnerIhk, alt: 'IHK: Industrie- und Handelskammer', h: 'h-12' },
  { src: partnerMorgenMorgen, alt: 'Morgen & Morgen: Das unabhängige Analysehaus', h: 'h-10' },
  { src: partnerFbXpert, alt: 'fb>xpert: Finanzberater Software', h: 'h-9' },
];

const marqueeItems = [...TRUST_ITEMS, ...TRUST_ITEMS];

const Index = () => {
  return (
    <div className="min-h-screen bg-background overflow-x-hidden">
      <SEO
        title="Finanzielle Bildung für Apotheker"
        description="Unabhängige, kostenfreie Finanzplanung für Apotheker und Pharmaziestudierende. Versicherungen, Altersvorsorge & Investment fundiert erklärt."
        canonical="/"
      />
      <Header />
      <main>
        <HeroSection />

        {/* Trust banner — white bg, overlapping hero transition */}
        <section className="relative bg-background -mt-2 md:-mt-4 z-20">
          <div className="max-w-[1100px] mx-auto px-6 py-6 md:py-8" aria-label="Auszeichnungen und Kooperationspartner">
            <p className="text-[10px] md:text-[11px] uppercase tracking-[0.22em] text-muted-foreground mb-4">
              Ausgezeichnet & vertraut von
            </p>
            <div
              className="group relative overflow-hidden"
              style={{
                maskImage:
                  'linear-gradient(to right, transparent, black 6%, black 94%, transparent)',
                WebkitMaskImage:
                  'linear-gradient(to right, transparent, black 6%, black 94%, transparent)',
              }}
            >
              <div className="flex w-max animate-marquee-x items-center gap-10 md:gap-12 pr-10 md:pr-12 group-hover:[animation-play-state:paused]">
                {marqueeItems.map((item, i) => (
                  <img
                    key={`${item.alt}-${i}`}
                    src={item.src}
                    alt={item.alt}
                    className={`${item.h} w-auto object-contain shrink-0 opacity-80 transition-transform duration-300 ease-out hover:scale-[1.18] md:hover:scale-125`}
                    loading="lazy"
                  />
                ))}
              </div>
            </div>
          </div>
        </section>

        <ServicesSection />
        <TestimonialsSection />
        <TopicsSection />
        <ProcessTimelineSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
